import { Spin } from "antd";
import { RootState } from "app.store";
import { shallowEqual, useSelector } from "react-redux";

export function Loading(props: any) {
  const isLoading = useSelector(
    (state: RootState) => state.globalValue.isLoading,
    shallowEqual
  );
  const isLoadingApp = useSelector(
    (state: RootState) => state.globalValue.isLoadingApp,
    shallowEqual
  );
  return isLoadingApp ? (
    <Spin></Spin>
  ) : (
    <Spin spinning={isLoading}>{props.children}</Spin>
  );
}
